<template>
    <menu-switch :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
      style="display:inline-block;padding-left:10px;position:relative;top:3px;" />
</template>

<script>
import MenuSwitch from './MenuSwitch';
import { mapGetters } from 'vuex';

export default {
  name: 'MenuSwitchButton',

  components: { MenuSwitch},

  computed: {
    ...mapGetters([
      'sidebar'
    ])
  },

  methods : {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sidebar/MenuSwitchButton.vue